import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Logo from '../components/Images/logo.png'
export default function Footer() {
  return (
    <Box component="footer" sx={{ bgcolor:'#f8f9ff', borderTop:'1px solid #e5e7ff', mt:6, py:5 }}>
      <Grid container spacing={3} maxWidth="lg" sx={{ mx:'auto', px:2 }}>
        <Grid item xs={12} md={4}>
          <Box sx={{ display:'flex', alignItems:'center', gap:1, mb:1 }}>
            <img src="/assets/logo-dark.svg" width="40" height="40" alt="Bloomington Restoration Services" />
            <Typography variant="h6">Bloomington Restoration Services</Typography>
          </Box>
          <Typography variant="body2" sx={{ mb:2 }}>
            121 W Kirkwood Ave, Bloomington, IN 47404<br/>
            Phone: <Link href="tel:+18125550123">+1 (812) 555-0123</Link><br/>
            Email: <Link href="mailto:info@bloomrestoration.com">info@bloomrestoration.com</Link>
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Serving Bloomington, Ellettsville, Bedford, Martinsville, Spencer, Unionville, and Monroe County.
          </Typography>
        </Grid>
        <Grid item xs={6} md={2}>
          <Typography variant="overline">Sitemap</Typography>
          <Box sx={{ display:'flex', flexDirection:'column', mt:1 }}>
            <Link component={RouterLink} to="/">Home</Link>
            <Link component={RouterLink} to="/about">About</Link>
            <Link component={RouterLink} to="/services">Services</Link>
            <Link component={RouterLink} to="/case-studies">Case Studies</Link>
            <Link component={RouterLink} to="/blog">Blog</Link>
            <Link component={RouterLink} to="/faq">FAQ</Link>
            <Link component={RouterLink} to="/privacy">Privacy</Link>
            <Link component={RouterLink} to="/terms">Terms</Link>
          </Box>
        </Grid>
        <Grid item xs={6} md={3}>
          <Typography variant="overline">Quick Contact</Typography>
          <Box component="form" onSubmit={(e)=>e.preventDefault()} sx={{ mt:1 }}>
            <TextField fullWidth size="small" label="Your email" sx={{ mb:1 }} />
            <Button variant="contained" fullWidth>Join Newsletter</Button>
          </Box>
        </Grid>
        <Grid item xs={12} md={3}>
          <Typography variant="overline">Follow</Typography>
          <Box sx={{ display:'flex', gap:2, mt:1 }}>
            <Link href="#" aria-label="Facebook">Facebook</Link>
            <Link href="#" aria-label="Instagram">Instagram</Link>
            <Link href="#" aria-label="LinkedIn">LinkedIn</Link>
          </Box>
        </Grid>
      </Grid>
      <Divider sx={{ my:3 }} />
      <Box maxWidth="lg" sx={{ mx:'auto', px:2 }}>
        <Typography variant="caption" color="text.secondary">
          ©Bloomington Restoration Services. All rights reserved.
        </Typography>
        {/* <script type="application/ld+json">
          {JSON.stringify({{
            "@context":"https://schema.org",
            "@type":"LocalBusiness",
            "name":"Bloomington Restoration Services",
            "image":"https://www.bloomrestoration.com/assets/images/og-default.svg",
            "telephone":"+1-812-555-0123",
            "address":{{
              "@type":"PostalAddress",
              "streetAddress":"121 W Kirkwood Ave",
              "addressLocality":"Bloomington",
              "addressRegion":"IN",
              "postalCode":"47404",
              "addressCountry":"US"
            }},
            "areaServed":[ "Bloomington IN","Ellettsville IN","Bedford IN","Martinsville IN","Spencer IN","Monroe County IN" ]
          }})}
        </script> */}
      </Box>
    </Box>
  );
}
